<template>
  <div>
    <div v-if="isNoGuidelineData" class="pa-4 text-xs-center">
      <v-icon color="warning">warning</v-icon>
      <br />
      No matching guidelines found
    </div>
    <v-list v-else dense class="pa-0 mx-0">
      <template v-if="filterToggle == filterToggles.selected">
        <template v-if="selectionCount > 0">
          <v-list-tile @click="() => {}" :disabled="disabled">
            <v-list-tile-action style="min-width: 0px;">
              <v-checkbox :disabled="disabled" color="primary" @click="untoggleAll()" hide-details :input-value="true" />
            </v-list-tile-action>
            <v-list-tile-avatar class="pl-0" style="min-width: 0px;">
              <v-icon>group_work</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content style="flex-grow: 1">Various</v-list-tile-content>
            <v-list-tile-content class="font-weight-light grey--text text--darken-0" style="flex-grow: 0;">
              <v-chip color="rgba(0,0,0,.07)" small>
                {{ selectionCount }}
              </v-chip>
            </v-list-tile-content>
            <v-list-tile-action class="ml-2" style="min-width: 0;">
              <v-icon>arrow_drop_up</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </template>
        <div v-else class="pa-4 text-xs-center">
          <v-icon color="warning">warning</v-icon><br />
          No guidelines selected
        </div>
      </template>
      <template v-for="(guidelines, category) in filteredItems">
        <v-list-tile :disabled="disabled" v-if="filterToggle == filterToggles.available" :key="`category-${category}`" @click="toggleExpand(category)">
          <v-list-tile-action style="min-width: 0px;">
            <v-checkbox :disabled="disabled" color="primary" :input-value="isSelected(category)" @click.stop="toggleCategory(category)" hide-details :indeterminate="isPartialSelection(category)" />
          </v-list-tile-action>
          <v-list-tile-avatar class="pl-0" style="min-width: 0px;">
            <v-icon>group_work</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content style="flex-grow: 1" v-text="category"></v-list-tile-content>
          <v-list-tile-content class="font-weight-light grey--text text--darken-0" style="flex-grow: 0;">
            <v-chip color="rgba(0,0,0,.07)" small>
              <span :class="{ 'error--text font-weight-bold': getGuidelinesLength(category) == 0 }">
                {{ getGuidelinesLength(category) }}
              </span>
            </v-chip>
          </v-list-tile-content>
          <v-list-tile-action class="ml-2" style="min-width: 0;">
            <v-icon>{{ categoryIndex[category].open || isSearching ? 'arrow_drop_up' : 'arrow_drop_down'}}</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <template v-if="categoryIndex[category].open || isSearching || filterToggle == filterToggles.selected">
          <v-list-tile :disabled="disabled || (atGuidelineLimit && !getGuidelineValue(guideline))" v-for="(guideline, index) in getAvailableGuidelines(guidelines)" :key="`guidelines-${category}-${index}`" @click="toggleGuideline(guideline.Id)">
            <v-list-tile-avatar style="min-width: 0px; flex-grow: 0; flex-shrink: 0;"></v-list-tile-avatar>
            <v-list-tile-action style="min-width: 0px; flex-grow: 0; flex-shrink: 0;" :class="{ 'align-button-checkbox-list': filterToggle == filterToggles.selected }">
              <v-checkbox v-if="filterToggle == filterToggles.available" color="primary" primary :input-value="getGuidelineValue(guideline)" hide-details />
              <v-btn v-else :disabled="disabled" large class="ma-0" icon>
                <v-icon color="primary">
                  check_box
                </v-icon>
              </v-btn>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-html="guideline.GuidelineName"></v-list-tile-title>
              <v-list-tile-sub-title>
                <v-tooltip :open-delay="600" bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ guideline.GuidelineLongName }}</span>
                  </template>
                  <span>{{ guideline.GuidelineLongName }}</span>
                </v-tooltip>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        <v-divider v-if="filterToggle == filterToggles.available" :key="`divider-${category}`" />
      </template>
    </v-list>
  </div>
</template>

<script>
  export default {
    props: {
      filterToggle: Number,
      filterToggles: Object,
      disabled: Boolean,
      guidelines: Array,
      search: String,
      selection: Object,
      selectionCount: Number,
      numMaxGuidelines: Number,
    },
    data() {
      return {
        filteredItems: {},
        menu: {
          show: false,
        },
        selected: {},
        categoryIndex: {},
      }
    },
    computed: {
      missingGuidelines: {
        get() {
          return this.$store.getters['multistation/missingParams'].guidelines
        },
        set(guidelines) {
          this.$store.dispatch('multistation/updateMissingParams', {
            guidelines,
          })
        },
      },
      atGuidelineLimit() {
        return this.selectionCount >= this.numMaxGuidelines
      },
      isNoGuidelineData() {
        return Object.keys(this.filteredItems).length == 0
      },
      categories() {
        return Object.keys(this.categoryIndex)
      },
      guidelineIndex() {
        let index = {}
        this.guidelines.forEach(guideline => index[guideline.Id] = guideline)
        return index
      },
      isSearching() {
        return this.search != null && this.search != ''
      },
      disabledGuidelines() {
        var result = {}
        let stationMediaTypes = this.selection.stationsMediaTypes
        let selectedMediaTypes = this.selection.mediaTypes

        if ((!stationMediaTypes || !stationMediaTypes.length) && (!selectedMediaTypes || !selectedMediaTypes.length)) return result

        this.guidelines.forEach(guideline => {
          if (selectedMediaTypes && selectedMediaTypes.length) {
            let hasMatch = false
            for (let i = 0; i < selectedMediaTypes.length; i++) {
              if (guideline.MediaTypes.has(selectedMediaTypes[i])) {
                hasMatch = true
                break
              }
            }
            if (!hasMatch) {
              result[guideline.Id] = true
              return
            }
          }

          if (stationMediaTypes && stationMediaTypes.length) {
            for (let i = 0; i < stationMediaTypes.length; i++) {
              if (guideline.MediaTypes.has(stationMediaTypes[i])) {
                return
              }
            }
            result[guideline.Id] = true
          }
        })

        return result
      },
    },
    watch: {
      search(value) {
        if (value) this.filteredItems = this.querySelection(value.toLowerCase())
        else this.filteredItems = this.querySelection('')
      },
      guidelines() {
        this.makeCategoryIndex()
        this.filteredItems = this.querySelection(this.search)
      },
      // Left here to show that emitSelected is needed, otherwise the deep: true property will cause a stack overflow.
      // selected: {
      //   deep: true,
      //   handler: function (value) {
      //     this.$emit('selected', value)
      //   },
      // },
    },
    methods: {
      emitSelected() {
        this.$emit('selected', this.selected)
      },
      getAvailableGuidelines(guidelines) {
        return guidelines.filter(guideline => (
          (!this.disabledGuidelines[guideline.Id] &&
            this.filterToggle == this.filterToggles.available) ||
          (this.filterToggle == this.filterToggles.selected && this.getGuidelineValue(guideline))
        ))
      },
      getGuidelinesLength(category) {
        let categoryIndex = this.categoryIndex[category]
        if (!categoryIndex) return 0
        return categoryIndex.guidelines.filter(guideline => !this.disabledGuidelines[guideline.Id]).length
      },
      makeCategoryIndex() {
        let index = {}
        this.guidelines.forEach(guideline => {
          if (!index[guideline.Category]) {
            index[guideline.Category] = {
              open: false,
              guidelines: [],
            }
          }

          index[guideline.Category].guidelines.push(guideline)
        })
        this.categoryIndex = index
        Object.keys(this.categoryIndex).forEach(category => {
          this.$set(this.selected, category, {})
        })

        this.emitSelected()
      },
      isPartialSelection(category) {
        if (this.atGuidelineLimit) return false
        let selection = this.selected[category]
        if (!selection) return
        let keyLength = Object.keys(selection).length
        return keyLength > 0 && keyLength != this.categoryIndex[category].guidelines.length
      },
      isSelected(category) {
        let selection = this.selected[category]
        if (!selection) return
        let keyLength = Object.keys(selection).length
        return keyLength > 0
      },
      querySelection(value) {
        this.loading = true

        let filteredCategories = Object.keys(this.categoryIndex).filter(category => category.toLowerCase().indexOf(
          value) > -1)
        let filteredGuidelines = this.guidelines.filter(guideline => guideline.GuidelineName.toLowerCase().indexOf(
          value) > -1)
        return this.makeFilteredItems(filteredCategories, filteredGuidelines)
      },
      makeFilteredItems(filteredCategories, guidelines) {
        let items = {}
        let categories = Object.keys(this.categoryIndex)

        categories.forEach(category => {
          let filteredGuidelines = guidelines.filter(guideline => guideline.Category == category)

          if (filteredCategories.indexOf(category) > -1) {
            items[category] = this.categoryIndex[category].guidelines
          } else if (filteredGuidelines.length > 0) {
            items[category] = filteredGuidelines
          }
        })

        return items
      },
      getGuidelineValue(guideline) {
        let selection = this.selected[guideline.Category]
        if (!selection) return
        return !!selection[guideline.Id]
      },
      toggleExpand(category) {
        this.categoryIndex[category].open = !this.categoryIndex[category].open
      },
      toggleGuideline(id) {
        let guideline = this.guidelineIndex[id]
        if (this.selected[guideline.Category][guideline.Id]) {
          this.$delete(this.selected[guideline.Category], guideline.Id)
        } else {
          this.$set(this.selected[guideline.Category], guideline.Id, guideline)
        }

        this.emitSelected()
      },
      toggleCategory(category) {
        this.selectionCount >= this.numMaxGuidelines

        let selected = this.selected[category]
        if (Object.keys(selected).length != Object.keys(this.categoryIndex[category].guidelines).length &&
          !this.atGuidelineLimit) {
          let filteredGuidelines = Object.values(this.filteredItems[category])
            .filter(guideline => !this.disabledGuidelines[guideline.Id])

          let maxLength = filteredGuidelines.length > this.numMaxGuidelines ?
            this.numMaxGuidelines : filteredGuidelines.length

          for (let i = 0; i < maxLength; i++) {
            let guideline = filteredGuidelines[i]
            this.$set(this.selected[category], guideline.Id, guideline)
          }
        } else {
          this.filteredItems[category].forEach(guideline => {
            this.$delete(this.selected[category], guideline.Id)
          })
        }

        this.emitSelected()
      },
      untoggleAll() {
        this.guidelines.forEach(guideline => {
          this.$delete(this.selected[guideline.Category], guideline.Id)
        })

        this.emitSelected()
      },
      selectGuidelineIds(guidelineIds) {
        this.untoggleAll()
        if (!guidelineIds) return

        let selected = JSON.parse(JSON.stringify(this.selected))
        let missingGuidelineIds = []
        guidelineIds.forEach(id => {
          let guideline = this.guidelines.find(g => g.Id == id)
          if (!guideline) {
            missingGuidelineIds.push(id)
          } else {
            selected[guideline.Category][guideline.Id] = guideline
          }
        })

        // Trigger DOM update all at once
        this.selected = selected
        this.emitSelected()
        this.missingGuidelines = missingGuidelineIds
      },
    },
    created() {
      this.makeCategoryIndex()
    },
    mounted() {
      this.filteredItems = this.querySelection(this.search)
    },
  }
</script>

<style>
  .single-line>a.v-list__tile.v-list__tile--link {
    height: 48px !important;
  }

  .three-line>a.v-list__tile.v-list__tile--link {
    height: 88px !important;
  }
</style>